var map = {
	"./blue/Ashi-guruma.webp": 8656,
	"./blue/Hane-goshi.webp": 6984,
	"./blue/Hara-gatame.webp": 1101,
	"./blue/Hiza-gatame.webp": 8797,
	"./blue/Kannuki-gatame.webp": 9004,
	"./blue/Kata-gatame.webp": 5062,
	"./blue/Kata-te-jime.webp": 3196,
	"./blue/Makura-kesa-gatame.webp": 743,
	"./blue/O-guruma.webp": 736,
	"./blue/Sankaku-gatame.webp": 8807,
	"./blue/Sankaku-jime.webp": 925,
	"./blue/Sode-guruma-jime.webp": 7134,
	"./blue/Soto-makikomi.webp": 4797,
	"./blue/Sumi-gaeshi.webp": 7359,
	"./blue/Tsubame-geashi.webp": 782,
	"./blue/Tsukomi-jime.webp": 4819,
	"./blue/Uchi-mata(hip).webp": 7954,
	"./blue/Uki-gatame.webp": 5820,
	"./blue/Uki-waza.webp": 8444,
	"./blue/Ura-nage.webp": 331,
	"./blue/Ushiro-goshi.webp": 6246,
	"./blue/Waki-gatame.webp": 2683,
	"./blue/Yoko-gake.webp": 8380,
	"./blue/Yoko-guruma.webp": 3099,
	"./blue/Yoko-otoshi.webp": 7026,
	"./brown/Kata-guruma.webp": 5828,
	"./brown/O-soto-guruma.webp": 100,
	"./brown/Sumi-otoshi.webp": 5182,
	"./brown/Uki-otoshi.webp": 4407,
	"./brown/Utsuri-goshi.webp": 4106,
	"./brown/Yoko-wakare.webp": 6433,
	"./green/Hadaka-jime.webp": 3186,
	"./green/Harai-tsuri-komi-ashi.webp": 2746,
	"./green/Kata-ha-jime.webp": 9429,
	"./green/Kesa-garami.webp": 8434,
	"./green/Kuzure-kami-shiho-gatame.webp": 1165,
	"./green/Kuzure-tate-shiho-gatame.webp": 19,
	"./green/Okuri-ashi-harai(barai).webp": 2596,
	"./green/Okuri-eri-jime.webp": 5639,
	"./green/Ryote-jime.webp": 4281,
	"./green/Sasae-tsuri-komi-ashi.webp": 9320,
	"./green/Seoi-otoshi.webp": 991,
	"./green/Sode-tsuri-komi-goshi.webp": 2599,
	"./green/Tani-otoshi.webp": 6749,
	"./green/Tomoe-nage.webp": 5892,
	"./green/Ude-gatame.webp": 2232,
	"./green/Ude-hishigi-ashi-gatame.webp": 2846,
	"./green/Uki-goshi.webp": 8316,
	"./green/Yoko-sumi-gaeshi.webp": 863,
	"./green/Yoko-tomoe-nage.webp": 1437,
	"./green/tsurikomigoshi.webp": 7177,
	"./orange/De-ashi-harai.webp": 3766,
	"./orange/Gyaku-juji-jime.webp": 2625,
	"./orange/Harai-goshi.webp": 6411,
	"./orange/Ippon-seoi-nage.webp": 9410,
	"./orange/Juji-gatame.webp": 2813,
	"./orange/Kata-juji-jime.webp": 1051,
	"./orange/Kesa-gatame.webp": 5433,
	"./orange/Ko-soto-gake.webp": 9280,
	"./orange/Kubi-nage.webp": 8198,
	"./orange/Kuzure-yoko-shiho-gatame.webp": 746,
	"./orange/Morote-seoi-nage.webp": 2358,
	"./orange/Nami-juji-jime.webp": 4987,
	"./orange/O-soto-gari.webp": 6636,
	"./orange/Tai-otoshi.webp": 8978,
	"./orange/Tsuri-goshi.webp": 8887,
	"./orange/Tsuri-komi-goshi.webp": 8672,
	"./orange/Uchi-mata.webp": 6068,
	"./orange/Ude-garami.webp": 4049,
	"./orange/Ushiro-kesa-gatame.webp": 6642,
	"./orange/Yoko-shiho-gatame.webp": 389,
	"./yellow/Eri-seoi-nage.webp": 1492,
	"./yellow/Hiza-guruma.webp": 699,
	"./yellow/Kami-shiho-gatame.webp": 1431,
	"./yellow/Ko-soto-gari.webp": 2712,
	"./yellow/Ko-uchi-gari.webp": 7099,
	"./yellow/Koshi-guruma.webp": 2859,
	"./yellow/Kuzure-kesa-gatame.webp": 6324,
	"./yellow/Mune-gatame.webp": 4118,
	"./yellow/O-goshi.webp": 6321,
	"./yellow/O-soto-otoshi.webp": 7637,
	"./yellow/O-uchi-gari.webp": 4894,
	"./yellow/Tate-shiho-gatame.webp": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8367;